<template>
  <div>
      <div class="contenedor-manual-formatos container mt-4 mb-5">
          <boton-atras :nombre_ruta="'modulo-planeacion'"></boton-atras>
          <div class="row">
              <!-- Columa con cards de los archivos -->
              <div class="col-md order-2 order-sm-2 order-md-1 order-lg-1">
                  <h6 class="subtitulo mb-2">Manual de Formatos</h6>
                  <div class="lineaNegra"></div>
                  <div class="mt-1 mb-2 lineaNegra2"></div>
                  <div class="text-mensaje my-3">
                      <h5><p>El Manual de formatos es el documento rector que estandariza los formatos oficiales e instructivos de llenado de la Secretaría de Finanzas</p></h5>
                  </div>
                  <a :href="urlSitioNuevo+'recursosPlaneacion/Manual_de_Formatos_de_la_Secretaría_de_Hacienda.pdf'" target="_blank">
                      <div class="mb-2">
                          <div class="title_document">
                              <div class="col-8">
                                  <h5>Manual de Formatos de la Secretaría de Hacienda</h5>
                              </div>
                              <div class="col-3">
                                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                              </div>
                          </div>
                      </div>
                  </a>
                  <!-- ---------- -->
                  <h4 class="subtitulo2 mt-5 ">Anexos del Manual de Formatos de la Secretaría de Hacienda</h4>






                  <!-- Anexo I -->
                  <!-- <a :href="urlSitioNuevo+'recursosPlaneacion/Anexo_I_Catalogo_de_Siglas.pdf'" target="_blank">
                      <div class="mb-2">
                          <div class="title_document">
                              <div class="col-8">
                                  <h5>Anexo I Catálogo de Siglas</h5>
                              </div>
                              <div class="col-3">
                                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                              </div>
                          </div>
                      </div>
                  </a> -->

                  <div class="accordion mt-4" id="accordionExample1">
                      <!-- Anexo I -->
                      <a :href="urlSitioNuevo+'recursosPlaneacion/Anexo_I_Catalogo_de_Siglas.pdf'" target="_blank" type="button" class="w-100">
                          <div class="mb-0 w-100">
                              <div class="title_document p-2 d-flex align-items-center" style="border-bottom-left-radius:0; border-bottom-right-radius:0">
                                  <div class="col-11 pr-0">
                                      <p class="m-0">Anexo I Catálogo de Siglas</p>
                                  </div>
                                  <div class="col-1 px-0 d-flex align-items-center justify-content-center">
                                      <p class="descargar text-gray m-0"><i class='bx bx-download icono-down'></i></p>
                                  </div>
                              </div>
                          </div>
                      </a>
                      <!-- Anexo II -->
                      <div class="card" style="border-radius: 0;">
                          <div class="card-header" id="headingOne" style="border-left: 3px solid #621132; border-radius:0; padding: 0 0.5rem">
                              <h2 class="mb-0">
                                  <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapse1" aria-expanded="true" aria-controls="collapseReglamento" style="display:flex; justify-content:space-between; ">
                                  <span><p class="m-0">Anexo II</p></span>
                                  <span class="descargar"><i class='bx bx-chevron-down icono-down'></i></span>
                                  </button>
                              </h2>
                          </div>
                          <div id="collapse1" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample1">
                              <div class="card-body">
                                  <ul> <!-- http://presupuesto.haciendachiapas.gob.mx/SAF/formatos/73/76/133/R6/SFUP001-F.pdf
                                            http://presupuesto.haciendachiapas.gob.mx/SAF/formatos/73/76/133/R6/SFUP001-I.pdf  -->
                                      <!-- <li><a :href="urlSitioNuevo+'recursosPlaneacion/Anexo_II_RESPONSIVA_SAF-MF.pdf'" target="_blank">Anexo II  RESPONSIVA SAF-MF</a> </li> -->
                                      <li><a :href="'http://presupuesto.'+urlSubdominio+'/SAF/formatos/73/76/133/R6/SFUP001-F.pdf'" target="_blank">Anexo II RESPONSIVA SAF -formulario</a> </li>
                                      <!-- <li><a :href="urlSitioNuevo+'recursosPlaneacion/Anexo_II.a_INSTRUCTIVO_RESPONSIVA_SAF-MF.pdf'" target="_blank">Anexo II.a  INSTRUCTIVO RESPONSIVA SAF-MF</a> </li> -->
                                      <li><a :href="'http://presupuesto.'+urlSubdominio+'/SAF/formatos/73/76/133/R6/SFUP001-I.pdf'" target="_blank">Anexo II.a INSTRUCTIVO RESPONSIVA SAF</a> </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                      <!-- Anexo III -->
                      <!-- <a :href="urlSitioNuevo+'recursosPlaneacion/Anexo_III_Cuerpo_de_Formato_Vertical.docx'" target="_blank">
                          <div class="mb-2 mt-4">
                              <div class="title_document">
                                  <div class="col-8">
                                      <h5>Anexo III: Cuerpo de formato vertical.</h5>
                                  </div>
                                  <div class="col-3">
                                      <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                  </div>
                              </div>
                          </div>
                      </a> -->
                      <div class="card">
                          <div class="card-header" id="headingTwo" style="border-left: 3px solid #621132; border-radius:0; padding: 0 0.5rem">
                              <h2 class="mb-0">
                                  <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapse2" aria-expanded="true" aria-controls="collapseReglamento" style="display:flex; justify-content:space-between;">
                                      <span><p class="m-0">Anexo III Cuerpo de Formato Vertical</p></span>
                                      <span class="descargar"><i class='bx bx-chevron-down icono-down'></i></span>
                                  </button>
                              </h2>
                          </div>
                          <div id="collapse2" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample1">
                              <div class="card-body">
                                  <ul>
                                      <!-- <li><a :href="urlSitioNuevo+'recursosPlaneacion/Anexo_III_Cuerpo_de_Formato_Vertical-MF.pdf'" target="_blank">Anexo III. Cuerpo de Formato Vertical-MF</a> </li> -->
                                      <li><a :href="urlSitioNuevo+'recursosPlaneacion/Anexo_III_Cuerpo_de_Formato_Vertical.docx'" target="_blank">Anexo III. Cuerpo de Formato Vertical</a> </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                      <!-- Anexo IV -->
                      <!-- <a class="d-none" :href="urlSitioNuevo+'recursosPlaneacion/Anexo_IV_Cuerpo_de _formato_Horizontal.docx'" target="_blank">
                          <div class="mb-2 mt-4">
                              <div class="title_document">
                                  <div class="col-8">
                                      <h5>Anexo IV Cuerpo de formato horizontal.</h5>
                                  </div>
                                  <div class="col-3">
                                      <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                  </div>
                              </div>
                          </div>
                      </a> -->
                      <div class="card">
                          <div class="card-header" id="headingThree" style="border-left: 3px solid #621132; border-radius:0; padding: 0 0.5rem">
                              <h2 class="mb-0">
                                  <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapse3" aria-expanded="true" aria-controls="collapseReglamento" style="display:flex; justify-content:space-between;">
                                      <span><p class="m-0">Anexo IV Cuerpo de formato horizontal</p></span>
                                      <span class="descargar"><i class='bx bx-chevron-down icono-down'></i></span>
                                  </button>
                              </h2>
                          </div>
                          <div id="collapse3" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample1">
                              <div class="card-body">
                                  <ul>
                                      <!-- <li><a :href="urlSitioNuevo+'recursosPlaneacion/Anexo_IV_Cuerpo_de _formato_Horizontal-MF.pdf'" target="_blank">Anexo IV. Cuerpo de  formato Horizontal-MF</a> </li> -->
                                      <li><a :href="urlSitioNuevo+'recursosPlaneacion/Anexo_IV_Cuerpo_de _formato_Horizontal.docx'" target="_blank">Anexo IV. Cuerpo de  formato Horizontal</a> </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                      <!-- Anexo V -->
                      <!-- <a class="d-none" :href="urlSitioNuevo+'recursosPlaneacion/Anexo_V_Cuerpo_de_Formato_Instructivo.docx'" target="_blank">
                          <div class="mb-2 mt-4">
                              <div class="title_document">
                                  <div class="col-8">
                                      <h5>Anexo V: Cuerpo instructivo de llenado</h5>
                                  </div>
                                  <div class="col-3">
                                      <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                  </div>
                              </div>
                          </div>
                      </a> -->
                      <div class="card">
                          <div class="card-header" id="headingFour" style="border-left: 3px solid #621132; border-top-left-radius:0; border-top-right-radius:0;  padding: 0 0.5rem">
                              <h2 class="mb-0">
                                  <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapse4" aria-expanded="true" aria-controls="collapseReglamento" style="display:flex; justify-content:space-between;">
                                      <span><p class="m-0">Anexo V: Cuerpo instructivo de llenado</p></span>
                                      <span class="descargar"><i class='bx bx-chevron-down icono-down'></i></span>
                                  </button>
                              </h2>
                          </div>
                          <div id="collapse4" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample1">
                              <div class="card-body">
                                  <ul>
                                      <!-- <li><a :href="urlSitioNuevo+'recursosPlaneacion/Anexo_V_Cuerpo_de_Formato_Instructivo-MF.pdf'" target="_blank">Anexo V. Cuerpo de Formato Instructivo-MF</a> </li> -->
                                      <li><a :href="urlSitioNuevo+'recursosPlaneacion/Anexo_V_Cuerpo_de_Formato_Instructivo.docx'" target="_blank">Anexo V. Cuerpo de Formato Instructivo</a> </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </div>





              </div>
              <!-- Columna con imagen -->
              <div class="col-md order-1 order-sm-1 order-md-2 order-lg-2 ">
                  <div class="row margenes img_fija">
                      <div class="sec_imagen">
                          <img src="@/assets/imagenes/reglamentoInterno.png" alt="">
                      </div>
                  </div>
              </div>
          </div>

      </div>


      <!-- =============solo estructura========================== -->
      <div class="d-none" style="height:80vh; display:flex; align-items:center;">
          <!-- <p>MANUAL DE FORMATOS</p> -->
          <div class="container">
              <div class="row">
                  <div class="col-12 border py-3">
                      <a target="_blank" href="http://localhost:8080/recursosPlaneacion/Manual de formatos.pdf">Manual de Formatos de la Secretaria de Hacienda</a>
                  </div>
                  <div class="col-12 border py-3">
                      <h5>Anexos del Manual de Formatos de la Secretaria de Hacienda</h5>
                      <ul>
                          <li><a target="_blank" href="http://localhost:8080/recursosPlaneacion/Anexo I. Catálogo de siglas.pdf">Anexo I: Catálogo de Siglas</a></li>
                          <li>Anexo II: </li>
                              <ul>
                                  <li><a target="_blank" href="http://localhost:8080/recursosPlaneacion/Anexo II RESPONSIVA SISTEMA ADMINISTRADOR DE FORMATOS I.pdf">Responsiva de Sistema Administrador de Formatos I.</a></li>
                                  <li><a target="_blank" href="http://localhost:8080/recursosPlaneacion/Anexo IIa INSTRUCTIVO RESPONSIVA SISTEMA ADMINISTRADOR DE FORMATOS F.pdf">Instructivo Responsiva de Sistema Administrador de Formatos.</a></li>
                              </ul>
                          <li><a target="_blank" href="http://localhost:8080/recursosPlaneacion/Anexo III. Cuerpo de Formato Vertical.docx">Anexo III: Cuerpo de formato vertical.</a></li>
                          <li><a target="_blank" href="http://localhost:8080/recursosPlaneacion/Anexo IV Cuerpo de  formato Horizontal.docx">Anexo IV Cuerpo de formato horizontal.</a></li>
                          <li><a target="_blank" href="http://localhost:8080/recursosPlaneacion/Anexo V Cuerpo de Formato Instructivo.docx">Anexo V: Cuerpo instructivo de llenado.</a></li>
                      </ul>
                  </div>

              </div>
          </div>
      </div>
  </div>
</template>
<script>
import botonAtras from '../../button-atras.vue'
export default {
  components:{
      botonAtras
  },
  mounted(){
      window.scrollTo(0, 0);
  },
}
</script>
